import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToasterService } from './toaster.service';
import { TosterMsgType } from './model';
import { LoaderService } from './loader.service';
import { ApiUrls, ConstantData } from './constants';
import { Observable, Subscriber } from 'rxjs';
// import { environment } from 'src/environments/environment.qa';



@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // Global environment Object
  get GlobalConstants(): any {
    return (<any>window).UIenvironments || environment;
  }

  // Getting all api url
  private apiUrl: any = ApiUrls.apiUrl;
  get isProduction(): boolean {
    if (this.GlobalConstants.server_url === this.GlobalConstants.allEnvironmentUrls?.find((env: any) => env?.name === 'Prod')?.url) {
      return true;
    }
    return false;
  }

  get redirectionUrl(): string {
    return this.GlobalConstants.redirectionUrl || '';
  }

  constructor(private http: HttpClient, private tosterService: ToasterService, private loaderService: LoaderService) { }

  /**
  method to make api calls
  @param type - post/get/delete/put
  @param url - api url that needs to be trigger
  @param body - Object that need to be pass in request
  @param applicationType - Content-Type
  @param nonJsonResponse - boolean value - true when response going to be string/boolean/number, false when reponse going to be Object/Array
  @param handleError - boolean value - true when want to handle the error and false when don't want to handle the error if any
  */
  handleRequest(type: string, url: string, body?: any, applicationType?: any, nonJsonResponse?: any, handleError: boolean = true, showLoader: boolean = true, isRawUrl: boolean = false): Promise<any> {
    url = isRawUrl ? url : (this.GlobalConstants.server_url + url);
    return new Promise((resolve, reject) => {
      if (showLoader) {
        this.loaderService.show();
      }
      this.makeRequest(type, url, body, applicationType).subscribe((res: any) => {
        setTimeout(() => {
          if (showLoader) {
            this.loaderService.hide();
          }
        }, 500);
        if (nonJsonResponse) {
          resolve(res.body);
        } else {
          resolve(res && res.body ? JSON.parse(res.body) : res);
        }
      }, (err: any) => {
        if (showLoader) {
          this.loaderService.hide();
        }
        let errObj = {};
        try {
          errObj = JSON.parse(err.error);
        } catch (errd) { }
        if (handleError)
          this.errorHandler(err, errObj);
        reject({ ...err, data: errObj, msg: (this.isJSONparsable(this.isJSONparsable(err.error)) || '') });
      });
    });
  }



  /**
  method to make api call's based on the type(post/get/delete/put) of the request.
  @param type - post/get/delete/put
  @param url - api url that needs to be trigger
  @param body - Object that need to be pass in request
  @param applicationType - Content-Type
  */
  makeRequest(type: string, url: string, body?: any, applicationType?: any) {
    switch (type) {
      case 'get': {
        return this.http.get(url, { responseType: 'text', observe: 'response' });
      }
      case 'blobFile':
        return this.getBlobFile(url);
      case 'post': {
        if (body) {
          return this.http.post(url, body, { responseType: 'text', observe: 'response' });
        } else {
          return this.http.post(url, { responseType: 'text', observe: 'response' });
        }
      }
      case 'put': {
        if (applicationType) {
          return this.http.put(url, body, {
            headers:
              { 'Content-Type': applicationType }, responseType: applicationType, observe: 'response'
          });
        } else {
          return this.http.put(url, body, { responseType: 'text', observe: 'response' });
        }
      }
      case 'patch': {
        return this.http.patch(url, body, { responseType: 'text', observe: 'response' });
      }
      case 'delete': {
        return this.http.delete(url, { responseType: 'text', observe: 'response' });
      }
      case 'deletelist': {
        return this.http.delete(url, { responseType: 'text', observe: 'response' });
      }
      default: {
        return this.http.get(url, { responseType: 'text', observe: 'response' });
      }
    }
  }




  /**
  method to check whether the  variable(err) is in json formate or not
  */
  private isJSONparsable(err: any) {
    try {
      const data = JSON.parse(err);
      const error: any = this.isJSONparsable(data.message || data.content.message);
      return (toString.call(error).split('').slice(8, -1).join('') === 'Object' ? error.message : error) || "";
    } catch (error) {
      if (toString.call(err).split('').slice(8, -1).join('') === 'Blob') {
        return err.message;
      }
      return err;
    }
    return "";
  }

  //This method fetches a blob file (e.g. a PDF).

  getBlobFile(url: any) {
    var blob;
    const observe = new Observable((s: any) => {
      this.http.get(url, { responseType: 'blob', observe: 'response' }).subscribe((response: HttpResponse<Blob>) => {
        // Convert the blob data into a Blob object and create a URL for it.
        const binaryData: any = [response.body]
        blob = window.URL.createObjectURL(new Blob(binaryData, { type: response.body?.type }))
        s.next({ blobFile: blob });
      }, (err: any) => {

        if (!err.error.message) {
          err.error.message = "Oops! Something went wrong";
        }
        s.error({ ...err });
      });
    });

    return observe;
  }




  /**
   * method to handle the error and based on the error shows the repective message.
   * @param err
   * @returns
   */
  errorHandler(err: any, errObj: any) {

    if (errObj.content && (Object.values(ConstantData.misMatchStatus).includes(errObj.content.errorStatusId)))
      return;
    var message: any = '';
    // if (err.error && this.isJSONparsable(err.error) && (JSON.parse(err.error).message || (JSON.parse(err.error).content && JSON.parse(err.error).content.message))) {
    message = this.isJSONparsable(this.isJSONparsable(err.error)) || '';

    // }else{
    //   message = err && err.error ? err.error : "";
    // }
    try {
      message = typeof message === 'string' ? message : message.content;
    } catch (err) {
      message = message;
    }


    if (message?.length > 100 || !message) {
      message = '';
    }


    if (message.toString().toLowerCase() === 'no message available'
      || message === 'Unauthorized access to the resource(INVESTOR)') { return; }
    switch (err.status) {
      case 400: {
        // TODO: Add Alert message
        this.tosterService.showMsg(message || 'Invalid URL Passed', TosterMsgType.ERROR);
        break;
      }
      case 500: {
        if (err.url.includes('risk/watchlist?asOn')) {
          let temp = JSON.parse(err.error);
          if (temp && temp.length) {
            let list: any = [];
            temp.forEach((res: any) => {
              let data = {
                assetClass: res.assetClass,
                entityName: res.entityName
              };
              list.push(data);
            });
            // TODO: Add Alert message
            this.tosterService.showMsg(JSON.stringify(list) + 'please check the sector', TosterMsgType.ERROR);
          } else {
            // TODO: Add Alert message
            this.tosterService.showMsg(message || 'Please try again later', TosterMsgType.ERROR);

          }
        } else {
          // TODO: Add Alert message
          this.tosterService.showMsg(message || 'Please try again later', TosterMsgType.ERROR);
        }
        break;
      }
      case 404: {
        // TODO: Add Alert message
        this.tosterService.showMsg(message || 'No Data Available', TosterMsgType.ERROR);
        break;
      }
      case 415: {
        // TODO: Add Alert message
        this.tosterService.showMsg(message || 'Invalid Content Type', TosterMsgType.ERROR);
        break;
      }
      // case 412:{
      //    // TODO: Add Alert message
      //    this.tosterService.showMsg(message || 'Please try again later', TosterMsgType.ERROR);
      //   break;
      // }
      /**
       * UnAuthorised Access
       * Force the user to login page
       **/
      case 401: {
        if (['Expired Token', 'Error Parsing Token'].indexOf(message) !== -1) {
          // TODO: Add Alert message
          this.tosterService.showMsg('Please try again', TosterMsgType.ERROR);
          // this.logger.setDataObservable('userstatus', 'expired');
        } else {
          // TODO: Add Alert message
          this.tosterService.showMsg(message || 'UnAuthorised Access', TosterMsgType.ERROR);
        }

        break;
      }
      case 405: {
        this.tosterService.showMsg(message || 'UnAuthorised Access', TosterMsgType.ERROR);
        break;
      }
      case 406: {
        this.tosterService.showMsg(message || 'Please try again', TosterMsgType.ERROR);
        break;
      }
      case 503: {
        this.tosterService.showMsg(message || 'Please try again', TosterMsgType.ERROR);
        break;
      }
    }
  }

  /**
 * method used to get the api url
 * @param target - string -
 * @param params - array or null - param/query param array that you need to pass in the url.
 * @returns string - api url
 */
  getUrl(target: string, params?: any[]): string {
    let urlData = this.apiUrl[target.split('_')[0]][target];


    if (params) {
      params.forEach((value: any, index: number) => {
        const paramName = 'param' + (index + 1);
        urlData = urlData.replace('{{' + paramName + '}}', value);

      });
    }

    return urlData;

  }


  getPincode(lat: number, lng: number) {
    return new Promise((res, rej) => {
      this.http.get(ConstantData.pincodeFile).subscribe((data: any) => {
        const pincodeData = data.filter((code:any)=> code.Latitude < Math.ceil(lat) && code.Latitude > Math.floor(lat) &&  code.Longitude < Math.ceil(lng) && code.Longitude > Math.floor(lng)).map((code:any)=> {
          return {
              ...code, 
              latDiff: Math.abs( (+code.Latitude) - lat),
              lngDiff: Math.abs( (+code.Longitude) - lng),
             
          }
      }).sort((a:any,b:any)=> {
          const isSort = ((a.latDiff - b.latDiff) > 0) && ((a.lngDiff - b.lngDiff) > 0); 
          return isSort? 1 : -1;
      })[0];

        res({
          circle:pincodeData.CircleName,
          district:pincodeData.District, 
          division:pincodeData.DivisionName, 
          lat: pincodeData.Latitude, 
          lng:pincodeData.Longitude,  
          pincode: pincodeData.Pincode, 
          region: pincodeData.RegionName, 
          state: pincodeData.StateName
        });
      }, (err) => {
        rej(err);
      });
    })


  }
}
